<template>
  <div class="card-container">
    <common-top-form
      :model="formModel"
      :submitService="submitService"
      :submitData="submitData"
      @success="onSuccess"
      selectShowPower="/bonusplan/select"
    >
      <el-form-item label="商户号">
        <el-input
          v-model="formModel.merCode"
          placeholder="请输入商户号"
        ></el-input>
      </el-form-item>
      <el-form-item label="商户手机号">
        <el-input v-model="formModel.layerPhone" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="联系人手机号">
        <el-input v-model="formModel.linkPhone" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="商户名称">
        <el-input v-model="formModel.merName" placeholder="请输入"></el-input>
      </el-form-item>
    </common-top-form>
    <common-table
      :data="tableData"
      ref="commonTable"
      @handleChange="getPage"
    >
      <el-table-column
        prop="merCode"
        label="商户号"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="merType"
        label="商户类型"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="merName"
        label="商户名称"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="shortName"
        label="商户简称"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="linkPhone"
        label="联系人手机号"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="linkmanName"
        label="联系人姓名"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="linkmanNbr"
        label="联系人身份证号"
        min-width="200"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="layerPhone"
        label="法人手机号"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="layerCertStime"
        label="法证开始日期"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="layerCertEtime"
        label="法证结束日期"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="email"
        label="223"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="province"
        label="省"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="city"
        label="市"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="county"
        label="区"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>

      <el-table-column
        prop="addr"
        label="地址"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="accType"
        label="结算类型"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="openBankCode"
        label="开户行联行号"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="openBankName"
        label="开户行名称"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="openProvince"
        label="开户行省"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="openCity"
        label="开户行市"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="bankCode"
        label="总行编号"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="bankName"
        label="总行名称"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="accountName"
        label="结算账户名"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="accountNbr"
        label="开户人身份证"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="accountNo"
        label="结算卡号"
        min-width="200"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="reservedMobile"
        label="结算卡手机号"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="busiLicenceNbr"
        label="营业执照号"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="busiStime"
        label="营业开始时间"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="busiEtime"
        label="营业结束时间"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="mccCode"
        label="营业范围编号"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="status"
        label="商户状态"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span v-if="scope.row.status == 0">正常</span>
          <span v-else-if="scope.row.status == 1">未开通（审核中）</span>
          <span v-else-if="scope.row.status == 2">失败</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="layerCertFacePho"
        label="法人身份证身份证正面"
        min-width="200"
      >
        <template slot-scope="scope">
          <image-viewer
            class="iconUrl"
            :src="scope.row.layerCertFacePho"
            alt="图片描述"
          ></image-viewer>
        </template>
      </el-table-column>
      <el-table-column
        prop="layerCertBackPho"
        label="法人身份证身份证反面"
        min-width="200"
      >
        <template slot-scope="scope">
          <image-viewer
            class="iconUrl"
            :src="scope.row.layerCertBackPho"
            alt="图片描述"
          ></image-viewer>
        </template>
      </el-table-column>
      <el-table-column
        prop="layerCertHoldPho"
        label="法人身份证手持身份证"
        min-width="200"
      >
        <template slot-scope="scope">
          <image-viewer
            class="iconUrl"
            :src="scope.row.layerCertHoldPho"
            alt="图片描述"
          ></image-viewer>
        </template>
      </el-table-column>
      <el-table-column
        prop="layerCertHoldPho"
        label="结算卡正面照片/开户许可证照片"
        min-width="250"
      >
        <template slot-scope="scope">
          <image-viewer
            class="iconUrl"
            :src="scope.row.bankImgPho"
            alt="图片描述"
          ></image-viewer>
        </template>
      </el-table-column>
      <el-table-column
        prop="bankImgBackPho"
        label="结算卡背面照片"
        min-width="150"
      >
        <template slot-scope="scope">
          <image-viewer
            class="iconUrl"
            :src="scope.row.bankImgPho"
            alt="图片描述"
          ></image-viewer>
        </template>
      </el-table-column>
      <el-table-column
        prop="busiLicencePho"
        label="企业营业执照图片"
        min-width="150"
      >
        <template slot-scope="scope">
          <image-viewer
            class="iconUrl"
            :src="scope.row.bankImgPho"
            alt="图片描述"
          ></image-viewer>
        </template>
      </el-table-column>
      <el-table-column label="操作" min-width="260" fixed="right">
        <template slot-scope="scope">
          <div style="display: flex; justify-content: center">
            <el-button type="text" @click="channelMerchant(scope.row)"
              >通道商户
            </el-button>
            <el-button type="text" @click="handleDelete(scope.row)"
              >删除
            </el-button>
          </div>
        </template>
      </el-table-column>
    </common-table>
  </div>
</template>

<script>
import ImageViewer from "../../dialog/ImageViewer";
import CommonTopForm from "components/common/CommonTopForm";
import CommonTable from "components/common/CommonTable";
import FormDialog from "../../dialog/FormDialog";
import ShowInfoDialog from "../../dialog/ShowInfoDialog";
import FinanceService from "service/FinanceService";
import { loadMixin, dialogMixin, validatorsMixin } from "mixin";
import { mapGetters } from "vuex";

export default {
  name: "bonusplan",
  components: {
    CommonTopForm,
    CommonTable,
    FormDialog,
    ShowInfoDialog,
    ImageViewer,
  },
  data() {
    return {
      dialogAmount: 0,
      show: false,
      formModel: {
        merCode: "",  // 商户号
        merName: "", // 商户名称
        linkPhone: "", // 联系人手机号
        layerPhone: "", // 商户手机号
      },
      tableData: [],
      multipleSelection: [],
      ids: [],
      submitService: FinanceService.PospApLiist,
      page: {},
      isPage: false,
     
    };
  },
  inject: ["reload"],
  mixins: [loadMixin, dialogMixin, validatorsMixin],
  mounted() {
    this.load();
  },
  computed: {
    submitData() {
      this.params = {
        merCode: this.formModel.merCode,
        merName: this.formModel.merName,
        linkPhone: this.formModel.linkPhone,
        layerPhone: this.formModel.layerPhone,
        current: this.isPage ? this.page.currentPage : 1,
        size: this.page.pageSize,
      };
      return this.params;
    },
    ...mapGetters(["serverType", "tatId", "userId"]),
  },
  watch: {},
  methods: {
    channelMerchant(row) {
      this.$router.push({
        name: "channelMerchant",
        params: {
          item: JSON.stringify(row),
        },
      });
    },
    load() {
      this.formModel = {
        date: "",
      };
      this.page = this.$refs.commonTable.page;
      this.getList();
    },
    getPage() {
      this.isPage = true;
      this.getList();
    },
    getList() {
      this.doLoad(
        this.submitService,
        this.submitData,
        (res) => {
          console.log(res, "resresres");
          this.doCheck(res, (res) => {
            this.onSuccess(res);
            this.isPage = false;
          });
        },
        "信息获取失败"
      );
    },
    handleDelete(item) {
      this.showConfirm("是否删除？")
        .then(() => {
          this.doDelete(item.id);
        })
        .catch(() => {});
    },
    doDelete(id) {
      this.doLoad(
        FinanceService.bonusplanDel,
        {
          id: id,
        },
        (res) => {
          this.doCheck(res, (res) => {
            this.commonSuccess(res);
          });
        },
        "操作失败"
      );
    },

  
    commonSuccess(res) {
      this.showSuccess(res.respMsg);
      this.getList();
    },
    onSuccess(res) {
     
      this.doCheck(res, (res) => {
        const result = res;
        this.tableData = result.contents.rows;
        this.page.currentPage = result.contents.current;
        this.page.total = result.contents.total;
        this.page.pageSize = result.contents.size;
      });
    },
   
  },
};
</script>

<style scoped>
.iconUrl {
  width: 50px;
  height: 50px;
  margin: auto;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/view/page/POSPmanage/merchantSupplierManagement.vue